<template>
  <div class="left">
    <div class="left-title">{{$t('个人中心')}}</div>
    <div class="line"></div>
    <ul class="menu">
      <li :class="index==0?'act':''"
          @click="goPage('/personal/order')">{{$t('我的订单')}} </li>
      <li :class="index==1?'act':''"
          @click="goPage('/personal/coupon')">{{$t('我的优惠券')}}</li>
      <li :class="index==2?'act':''"
          @click="goPage('/personal/myFp')">
          {{$t('我的发票')}} </li>
      <li class="line2"></li>
      <li :class="index==3?'act':''"
          @click="goPage('/personal/index')">{{$t('账号管理')}}</li>
      <li :class="index==4?'act':''"
          @click="goPage('/personal/addAddress')">{{$t('我的收货地址')}}</li>
      <!-- <li class="line3"></li> -->
      <li :class="index==5?'act':''"
          @click="goPage('/personal/integral')">{{$t('我的积分')}}</li>

      <li :class="index==6?'act':''"
          @click="goPage('/personal/footprint')">{{$t('足迹')}}</li>
    </ul>

  </div>
</template>

<script>
export default {
  name: "personal-left",
  props: {
    index: {
      type: String | Number
    }
  },

  methods: {
    goPage (item) {
      if (item) {
        this.$router.push({
          path: item,
        })
      } else {
        this.$jx.open1('正在开发中')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.left {
  margin-right: 43.5px;

  .left-title {
    font-size: 19px;
    font-weight: bold;
    color: #191e1f;
  }
}
.menu {
  font-size: 14px;
  font-weight: 400;
  color: #191e1f;
  li {
    padding-left: 10px;
    line-height: 25px;
    margin-bottom: 20px;
  }
}
.line {
  margin: 21px 0 17px;
  background: #ffffff;
  border: 0.5px solid #dddddd;
}
.line2 {
  width: 114px;
  margin-right: 0 !important;
  background: #ffffff;
  border: 0.5px solid #dddddd;
  margin: 13px 0 09px;
}
.line3 {
  width: 114px;
  margin-right: 0 !important;
  background: #ffffff;
  border: 0.5px solid #dddddd;
  margin: 15px 0 16px;
}
.act {
  font-weight: bold;
  background-color: #def1fc;
  margin-right: 20px;
  border-radius: 0 30px 30px 0;
}
</style>





















// WEBPACK FOOTER //
// src/components/personal/personal-left.vue